<template>
    <div class="mr-10">
        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
            {{ snackbar_message }}
        </v-snackbar>

        <div>
            <v-layout column>
                <v-flex offset-xs8>
                    <v-layout row>
                        <v-btn rounded color="primary" class="text-capitalize mr-2" to="/organizations/new"
                            v-if="$can('create organizations')">
                            Ajouter
                            <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>

                        <v-btn rounded color="primary" class="text-capitalize mr-2" v-if="$can('export organizations')">
                            <export-excel :data="organizations" name="Organisations.xls" :export-fields="org_fields">
                                Exporter
                                <v-icon right>mdi-share-outline</v-icon>
                            </export-excel>
                        </v-btn>

                        <v-btn :loading="loadExcel" :disabled="loadExcel" rounded color="primary"
                            class="text-capitalize" v-if="$can('export organizations')"
                            @click="printGlobaleWithActors()">
                            Exporter Global
                            <v-icon right>mdi-share-outline</v-icon>
                        </v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
        <v-layout row wrap class="mt-5 mr-2">
            <v-select v-model="search_department" :items="liste_dep" item-text="name" item-value="id" clearable solo
                label="Département" @change="fetchUtils()" class="ml-2 mr-2"></v-select>

            <v-text-field v-model="search" label="Rechercher une organisation" append-icon="mdi-magnify" solo class="">
            </v-text-field>
        </v-layout>

        <v-data-table v-if="organizations" :headers="headers" :items="organizations" :loading="loading" sort-by="name"
            :search="search" :page.sync="currentPage" :server-items-length="orgTotalItems"
            :items-per-page.sync="rowsPerPageItems" :footer-props="footerProps" class="elevation-1 mt-2">
            <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="showItem(item.id)" v-if="$can('view organizations')">
                    mdi-eye-outline
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item.id)" v-if="$can('edit organizations')">
                    mdi-pencil-outline
                </v-icon>
                <v-icon small @click="isDeletingOrg(item)" v-if="$can('delete organizations')">
                    mdi-trash-can-outline
                </v-icon>
            </template>
        </v-data-table>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_deletion" max-width="290">
                <v-card>
                    <v-card-title class="headline">Suppression</v-card-title>
                    <v-card-text class="text-center">
                        Etes-vous sûr de vouloir supprimer cette organisation ?
                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="orange" rounded @click="dialog_deletion = false">
                            <span class="white-couleur">Non</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" :loading="load" :disabled="load" rounded @click="delOrganization()">
                            Oui
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios";
import Permissions from "~/mixins/Permissions";
import FileSaver from 'file-saver'

export default {
    name: "organizations-list",
    mixins: [Permissions],
    data: () => ({
        snackbar: false,
        loading: false,
        load: false,
        snackbar_message: "",
        snackbar_timeout: 5000,
        snackbar_color: "",
        del_org: null,
        del_index: null,
        search: "",
        dialog_edit: false,
        dialog_deletion: false,
        loadExcel: false,
        headers: [
            { text: "Organisation", value: "name" },
            { text: "Type", value: "type" },
            { text: "Village", value: "town.name" },
            { text: "Chaine de valeur", value: "chain.name" },
            { text: "Date de création", value: "creation_date" },
            { text: "Actions", value: "action", sortable: false }
        ],
        org_fields: {
            Organisation: "name",
            Type: "type",
            Village: "town.name",
            "Chaine de valeur": "chain.name",
            "Date de création": "creation_date"
        },
        editedIndex: -1,
        editedItem: {
            name: "",
            type: "",
            pea: "",
            department_id: null,
            value_chain_id: null,
            maillon_id: null
        },
        defaultItem: {
            name: "",
            type: "",
            pea: "",
            department_id: null,
            value_chain_id: null,
            maillon_id: null
        },
        payload: {
            query: {
                page: 1,
                query: 15
            }
        },
        footerProps: {
            "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
            "items-per-page-text": "Lignes par page"
        },
        organizations: [],
        orgTotalItems: null,
        rowsPerPageItems: null,
        currentPage: null,
        search_department: null,

    }),
    created() {
        this.$checkPermission("view organizations");
    },
    mounted() {
        this.fetchUtils();
    },

    computed: {
        new_org_added: {
            get: function () {
                return this.$route.params.new_org_added;
            },

            set: function (value) {
                this.$route.params.new_org_added = value;
            }
        },
        upd_org_added: {
            get: function () {
                return this.$route.params.upd_org_added;
            },

            set: function (value) {
                this.$route.params.upd_org_added = value;
            }
        },
        org_deleted: {
            get: function () {
                return this.$route.params.org_deleted;
            },

            set: function (value) {
                this.$route.params.org_deleted = value;
            }
        },
        liste_dep() {
            return this.$store.getters.departments.filter(function (departement) {
                return (
                    departement.name === "COLLINES" ||
                    departement.name === "BORGOU" ||
                    departement.name === "DONGA"
                );
            });
        }
    },

    watch: {
        rowsPerPageItems(newVal, oldVal) {
            if (newVal != oldVal) {
                this.payload.query.size = newVal;
                this.fetchUtils();
            }
        },
        currentPage(newVal, oldVal) {
            if (newVal != oldVal) {
                this.payload.query.page = newVal;
                this.fetchUtils();
            }
        },
        search(newVal, oldVal) {
            if (newVal != oldVal) {
                this.payload.query.search = newVal;
                this.fetchUtils();
            }
        }
    },

    methods: {
        async fetchUtils() {
            this.loading = true;
            let uri = `/api/organizations?include=country,department,municipality,district,town,chain,maillon`;

            if (this.search_department) {
                uri = uri + '&department_id=' + this.search_department
            }
            await axios
                .get(uri, { params: this.payload.query })
                .then(result => {
                    this.currentPage = result.data.current_page;
                    this.orgTotalItems = result.data.total;
                    this.rowsPerPageItems = parseInt(result.data.per_page);
                    this.organizations = result.data.data;
                    this.loading = false;
                });

            if (this.new_org_added) {
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message =
                    "Nouvelle organisation enregistrée avec succès !";
                this.new_org_added = null;
            } else if (this.upd_org_added) {
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message =
                    "Organisation mise à jour avec succès !";
                this.upd_org_added = null;
            } else if (this.org_deleted) {
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message = "Organisation supprimée avec succès !";
                this.org_deleted = null;
            }
        },

        showItem(id) {
            this.$router.push({
                name: "organizations.show",
                params: { Pid: id }
            });
        },

        editItem(id) {
            this.$router.push({
                name: "organizations.edit",
                params: { Pid: id }
            });
        },

        isDeletingOrg(item) {
            this.del_index = this.organizations.indexOf(item);
            this.dialog_deletion = true;
            this.del_org = item.id;
        },

        delOrganization() {
            if (this.del_org) {
                this.load = true;
                const uri = "/api/organizations/" + this.del_org;
                let objet = this;

                axios
                    .delete(uri)
                    .then(response => {
                        this.fetchUtils();
                        objet.dialog_deletion = false;
                        objet.snackbar = true;
                        objet.snackbar_color = "success";
                        objet.snackbar_message = "Organisation supprimée !";

                        // this.organizations.splice(this.del_index, 1);
                    })
                    .catch(err => {
                        console.log("Organization deletion error ", err);
                    });
                this.load = false;
            }
        },

        async printGlobale() {

            this.loadExcel = true

            axios
                .get('/api/print-organizations', {
                    responseType: 'blob'
                })
                .then((resp) => {
                    FileSaver.saveAs(
                        resp.data,
                        'liste des organisations.xlsx'
                    )

                    this.loadExcel = false
                })
                .catch((err) => {
                    this.loadExcel = false
                    this.$store.dispatch('responseMessage', {
                        type: 'red',
                        text: err
                    })
                })
        },

        async printGlobaleWithActors() {

            this.loadExcel = true

            axios
                .get('/api/print-organizations-with-actors', {
                    responseType: 'blob'
                })
                .then((resp) => {
                    FileSaver.saveAs(
                        resp.data,
                        'liste des organisations avec les acteurs.xlsx'
                    )

                    this.loadExcel = false
                })
                .catch((err) => {
                    this.loadExcel = false
                    this.$store.dispatch('responseMessage', {
                        type: 'red',
                        text: err
                    })
                })

        }
    }
};
</script>

<style scoped>
.couleur-orange {
    color: rgb(255, 152, 0);

    font-size: 1.2em;
}

.white-couleur {
    color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/organizations/index.vue